import { Badge, Grid, GridItem, HStack, Td, Tr, useToast } from "@chakra-ui/react";
import { Form, IconButton, Profile, Section, Switcher, Table, Tag } from "components";
import Limit from "./limit";
import { useParams } from "react-router";
import { useProduct } from "hooks";
import { useState } from "react";
import { API } from "config";

export default function Options(){

    const toast = useToast()
    const params = useParams()
    const product = useProduct(params.id)
    const [ loading, setLoading ] = useState(false)

    const handleToggle = async (field) => {
        setLoading(field)

        try{
            await API.post(`/products/${product.data?.id}`, { [field]: !product.data?.[field], _method: 'put' })
            toast({ title: 'Alteração realizada', status: 'success' })
            product.refetch()
        }catch(err){
            toast({ title: 'Não foi possível alterar agora. Tente novamente', description: err?.responser?.data?.message, status: 'warning' })
        }

        setLoading(false)
    }
    
    return(
    <>
    <Section title="Opções do produto">

    </Section>

    <Grid templateColumns="49% 49%" gap={6}>

        <GridItem>
            <Switcher isDisabled={loading||product.isFetching} loading={loading==='available_for_distributor'} onClick={() => handleToggle('available_for_distributor')} value={product.data?.available_for_distributor} title="Compra de núcleos" description="Permite que núcleos comprem este produto da Matriz" />
        </GridItem>

        <GridItem>
            <Switcher isDisabled={loading||product.isFetching} loading={loading==='available_for_consultant'} onClick={() => handleToggle('available_for_consultant')} value={product.data?.available_for_consultant} title="Compra de consultores" description="Permite que consultores comprem este produto da Matriz" />
        </GridItem>

    </Grid>

    <Limit />
    </>
    )
}